import toast from 'react-hot-toast';
import { useMutation } from 'react-query';

import { trackLeadInOptimizely } from '@tracking';
import { CreateUserParams, createUser } from '@utils/backend-api/users';

const useUserCreate = () => {
  const { mutate, mutateAsync, isLoading, isError } = useMutation(
    (params: CreateUserParams) => createUser(params),
    {
      onError: (error: { message: string; redirect_to?: string }) => {
        toast.error(error.message);
        if (error.redirect_to) {
          window.location.href = error.redirect_to;
        }
      },
      onSuccess: (response) => {
        trackLeadInOptimizely(response);
      },
    }
  );
  return { mutate, mutateAsync, isLoading, isError };
};

export default useUserCreate;
